import { Action, ErrorCodes, OperationType, Position, WindowType } from "puzzle";

export const createTemplate: Action = [{
  data: {
    path: '/view/template'
  },
  moduleName: 'App',
  type: OperationType.redirect
}, {
  data: {
    submissionMode: 'TEMPLATE_CREATE'
  },
  moduleName: 'SubmissionCrossover',
  name: 'setMode',
  args: ['submissionMode'],
  waitForModule: true
}, {
  name: 'reloadCreateSubmission',
  type: OperationType.action
}];

export const reloadTemplates: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'userPromise',
  type: OperationType.action
}, {
  name: 'getMainGridInitialData',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];


export const createFromTemplate: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    path: '/view/submission'
  },
  moduleName: 'App',
  type: OperationType.redirect
}, {
  name: 'getTemplateData',
  type: OperationType.action
}, {
  moduleName: 'SubmissionCrossover',
  name: 'setMode',
  args: ['submissionMode'],
  waitForModule: true
}, {
  moduleName: 'Details',
  name: 'setTemplateId',
  args: ['selectedTemplate']
}, {
  condition: '{submissionData.batchInfos.length} > 1',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          projectId: '_.get({submissionData}, "projectId")'
        }
      }
    },
    moduleName: 'DropUpload',
    moduleId: 'MultiBatchUpload_0',
    name: 'startFileUpload',
    args: ['files', 'projectId']
  }],
  elseOperations: [{
    moduleName: 'DropUpload',
    moduleId: 'fromContent',
    name: 'beforeUploadStart',
    args: ['files']
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getTemplateData: Action = [{
  data: {
    template: {
      submissionData: {
        bind: {
          submissionId: '{selectedTemplate}',
          submissionMode: '{submissionMode}'
        }
      },
      afterTemplateChange: true
    }
  },
  name: 'getSubmissionData',
  type: OperationType.action
}, {
  persistent: ['selectedTemplate'],
  type: OperationType.removePersistentData
}];

export const confirmTemplateChange: Action = [{
  persistent: ['selectedTemplate'],
  type: OperationType.addPersistentData
}, {
  condition: '{oldTemplateId}',
  conditionOperations: [{
    items: [{
      operations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
      btnName: 'changeTemplateConfirm.no',
      btnConfig: {
        pos: Position.end,
        fillMode: 'flat'
      }
    }, {
      operations: [{
        name: 'changeTemplate',
        type: OperationType.action
      }],
      btnName: 'changeTemplateConfirm.yes',
      btnConfig: {
        pos: Position.end,
        themeColor: 'success'
      }
    }],
    className: 'sm confirm-light',
    text: 'changeTemplateConfirm.text',
    title: 'changeTemplateConfirm.title',
    type: OperationType.warning,
    closable: false
  }],
  elseOperations: [{
    name: 'changeTemplate',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const changeTemplate: Action = [{
  moduleName: 'Details',
  name: 'setTemplateId',
  args: ['selectedTemplate']
}, {
  condition: '{selectedTemplate}',
  conditionOperations: [{
    name: 'getTemplateData',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];


export const deleteTemplate: Action = [{
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      persistent: ['submissionId'],
      type: OperationType.removePersistentData
    }],
    btnName: 'deleteTemplate.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          method: 'delete',
          bind: {
            url: '"/submissions/" + {submissionId}',
          }
        }
      },
      handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
      mappingName: 'deleteSubmissionResponse',
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            responseData: '{deleteSubmissionResponse}',
          }
        }
      },
      name: 'handleRequestException',
      type: OperationType.action
    }, {
      persistent: ['submissionId'],
      type: OperationType.removePersistentData
    }, {
      name: 'refreshMainGridOnCurrentPosition',
      type: OperationType.action
    }, {
      name: 'closeDrawer',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    btnName: 'deleteTemplate.yes',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error',
    }
  }],
  className: 'sm confirm-light',
  text: 'deleteTemplate.text',
  title: 'deleteTemplate.title',
  type: OperationType.warning
}];
